import React from 'react';
import { Zap } from 'lucide-react';
export function TopBar() {
  return <div className="bg-[#E8441A] text-white py-2 px-4 text-center text-sm font-medium flex items-center justify-center gap-2" data-id="element-86">
      <Zap size={16} className="fill-current" data-id="element-87" />
      <span data-id="element-88">Limited Time Offer — Free Shipping Today Only!</span>
    </div>;
}